interface Props {
  listenToColor: boolean;
  listenToDownpayTime: boolean;
  listenToPlanId: boolean;
  listenToStorage: boolean;
}

export const usePdpListenToViewItem = (props: Props): void => {
  const { pushViewItemEvent } = useGoogleAnalyticsEvents();
  const productPageStore = useMyProductPageStore();

  const selectedColor = computed(
    () => productPageStore.productState.selectedColor,
  );
  const selectedStorage = computed(
    () => productPageStore.productState.selectedStorage,
  );
  const selectedDownPaymentTime = computed(
    () => productPageStore.productState.selectedDownPaymentTime,
  );
  const selectedPlanId = computed(
    () => productPageStore.productState.selectedPlanId,
  );

  const pushTrackEvent = () => {
    pushViewItemEvent(productPageStore.trackingData);
  };

  let isMounted = false;

  onMounted(() => {
    isMounted = true;
    pushTrackEvent();
  });

  watch(
    [
      props.listenToColor ? selectedColor : null,
      props.listenToDownpayTime ? selectedDownPaymentTime : null,
      props.listenToPlanId ? selectedPlanId : null,
      props.listenToStorage ? selectedStorage : null,
    ].filter(Boolean),
    () => {
      if (!isMounted) {
        return;
      }
      pushTrackEvent();
    },
  );
};
